import { useCallback } from "react";

import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import useUiuxStore from "src/store/useUiuxStore";

import { useTQC3010_R01Store } from "./Store_TQC3010_R01";
import {BRDiv} from "src/components/common/common";

interface EmployeeSearchResult {
	empNo?: string;
	empNm?: string;
}

export const Info_TQC3010_R01 = () => {
	const { setCodeSearchModalProps } = useUiuxStore();
	const {
		TQC3010_R01Info,
		setTQC3010_R01Info,
		selectedTQC3010_R01,
	} = useTQC3010_R01Store();

	const openEmployeeModal = useCallback(
		(field: "inspector" | "approvor") => {
			const isInspector = field === "inspector";
			setCodeSearchModalProps({
				category: isInspector ? "검사자" : "승인자",
				search: isInspector
					? TQC3010_R01Info.inspectorEmp
					: TQC3010_R01Info.approvorEmpno,
				formName: "TQC3010_R01",
				isInfo: true,
				handleFoucsId: isInspector
					? "tqc3010_inspectorEmp"
					: "tqc3010_approvorEmpno",
				wrapperOption: { size: "md", width: 50, overlay: true },
				onClear: () =>
					setTQC3010_R01Info(
						isInspector
							? { inspectorEmp: "", inspectorEmpNm: "" }
							: { approvorEmpno: "", approvorEmpNm: "" },
					),
				onConfirm: (data: EmployeeSearchResult) =>
					setTQC3010_R01Info(
						isInspector
							? { inspectorEmp: data.empNo || "", inspectorEmpNm: data.empNm || "" }
							: { approvorEmpno: data.empNo || "", approvorEmpNm: data.empNm || "" },
					),
			});
		},
		[setCodeSearchModalProps, setTQC3010_R01Info, TQC3010_R01Info],
	);

	return (
		<div className="w-full h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] pb-[6px] overflow-y-auto border border-gray-300 bg-white">
			<InputForm
				title="거래처"
				name="customNm"
				value={selectedTQC3010_R01?.customNm ?? ""}
				editable={false}
			/>
			<InputForm
				title="품목"
				name="itemNm"
				value={selectedTQC3010_R01?.itemNm ?? ""}
				editable={false}
			/>
			<InputForm
				title="LotNo"
				name="lotNo"
				value={selectedTQC3010_R01?.lotNo ?? ""}
				editable={false}
			/>

			<InputForm
				title="검사구분"
				name="inspectType"
				value="출하검사"
				editable={false}
			/>
            <BRDiv/>
            <CodeForm
                label="검사자"
                name="inspectorEmp"
                value={TQC3010_R01Info.inspectorEmp}
                custNmValue={TQC3010_R01Info.inspectorEmpNm}
                handleFoucsId="tqc3010_inspectorEmp"
                handleChange={(event) =>
                    setTQC3010_R01Info({ inspectorEmp: event.target.value })
                }
                onDoubleClick={() => openEmployeeModal("inspector")}
            />
			<CodeForm
				label="승인자"
				name="approvorEmpno"
				value={TQC3010_R01Info.approvorEmpno}
				custNmValue={TQC3010_R01Info.approvorEmpNm}
				handleFoucsId="tqc3010_approvorEmpno"
				handleChange={(event) =>
					setTQC3010_R01Info({ approvorEmpno: event.target.value })
				}
				onDoubleClick={() => openEmployeeModal("approvor")}
			/>
		</div>
	);
};
